/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { listProfileAwards } from '../fn/profile-award/list-profile-awards';
import { ListProfileAwards$Params } from '../fn/profile-award/list-profile-awards';
import { ProfileAward } from '../models/profile-award';

@Injectable({ providedIn: 'root' })
export class ProfileAwardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProfileAwards()` */
  static readonly ListProfileAwardsPath = '/rest/profile/{id}/award';

  /**
   * List all awards given to profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileAwards()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileAwards$Response(params: ListProfileAwards$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAward>>> {
    return listProfileAwards(this.http, this.rootUrl, params, context);
  }

  /**
   * List all awards given to profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileAwards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileAwards(params: ListProfileAwards$Params, context?: HttpContext): Observable<Array<ProfileAward>> {
    return this.listProfileAwards$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAward>>): Array<ProfileAward> => r.body)
    );
  }

}
